import { IOfferDescriptionVisualParameter } from "./IOfferDescriptionVisualParameter";
/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 16.04.13
 * Time: 08:55
 */

import { BasicPrivateOfferVO } from "../../BasicPrivateOfferVO";
import { Constants_Offer } from "../../Constants_Offer";
import { PrivateOfferStateEnum } from "../../PrivateOfferStateEnum";

/**
 * Visual component to show a finish dialog if offer has offer succeeded state
 */
export class OfferDescriptionVisualFinishDialog implements IOfferDescriptionVisualParameter {
    private _dialogName: string;

    constructor(dialogName: string) {
        this._dialogName = dialogName;
    }

    public get name(): string {
        return Constants_Offer.OFFER_VISUAL_FINISH_DIALOG;
    }

    public parseFromObjectParam(params: any): void {
        this._dialogName = params.DN;
    }

    public execute(offerVO: BasicPrivateOfferVO): boolean {
        // show finish dialog with registered dialog name
        // OVERRIDE TO EXECUTE DIALOGHANDLER
        //BasicDialogHandler.getInstance().registerDialogs(_dialogName, new BasicPrivateOfferDialogProperties(offerVO));
        return true;
    }

    public toExecuteInState(state: PrivateOfferStateEnum): boolean {
        return state === PrivateOfferStateEnum.OFFER_SUCCEEDED;
    }

    public get dialogName(): string {
        return this._dialogName;
    }

    public dispose(): void {
        this._dialogName = null;
    }

    public getCommandName(): string {
        return "PRIVATE_OFFER_FINISH_DIALOG";
    }
}

